import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import authFetch from '../utils/authFetch';
import API_BASE_URL from '../config';

const normalizeRole = (role) => (role === 'warden' ? 'superuser' : role);

const ProtectedRoute = ({ children, requiredRole, redirectTo }) => {
  const [authState, setAuthState] = useState('loading'); // 'loading' | 'authenticated' | 'unauthenticated'
  const [verifiedRole, setVerifiedRole] = useState(null);

  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (!user || !token) {
      setAuthState('unauthenticated');
      return;
    }

    authFetch(`${API_BASE_URL}/api/auth/me`)
      .then(res => {
        if (!res.ok) throw new Error('Invalid token');
        return res.json();
      })
      .then(data => {
        setVerifiedRole(normalizeRole(data.role));
        setAuthState('authenticated');
      })
      .catch(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setAuthState('unauthenticated');
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (authState === 'loading') {
    return null;
  }

  if (authState === 'unauthenticated') {
    return <Navigate to={redirectTo} replace />;
  }

  const role = normalizeRole(verifiedRole || user?.role || user?.user_type);

  if (requiredRole) {
    const roles = (Array.isArray(requiredRole) ? requiredRole : [requiredRole]).map(normalizeRole);
    if (!roles.includes(role)) {
      if (role === 'superuser') return <Navigate to="/su-homepage" replace />;
      if (role === 'admin') return <Navigate to="/sa-homepage" replace />;
      if (role === 'jail_officer') return <Navigate to="/jo-homepage" replace />;
      return <Navigate to={redirectTo} replace />;
    }
  } else {
    if (role === 'superuser') return <Navigate to="/su-homepage" replace />;
    if (role === 'admin') return <Navigate to="/sa-homepage" replace />;
    if (role === 'jail_officer') return <Navigate to="/jo-homepage" replace />;
  }
  
  return children;
};

export default ProtectedRoute;